import getQueryParameter from './getQueryParameter';
import SCORM from './SCORM';
import findTopWindow from './findTopWindow';

/**
 * Firm codes that automatically enable edit mode for demo/review purposes.
 * These modes allow editing but don't persist changes.
 */
const REVIEW_MODE_FIRM_CODES = ['REVIEW', 'VINCI_ADMIN'];

const queryTags = getQueryParameter('tags');
const audioDoc = Boolean(getQueryParameter('audioDoc'));
const wordDoc =
  Boolean(queryTags?.includes('worddoc')) || Boolean(getQueryParameter('word'));

export let isAuthoring = false;
declare const __AUTHORING__: boolean;

if (__AUTHORING__) {
  const editorWindow = findTopWindow({
    withOpeners: true,
    predicate: w => 'acceptFromPreview' in w
  });

  isAuthoring = editorWindow !== window;
}

let isEditModeAvailable =
  (isAuthoring ||
    Boolean(getQueryParameter('edit')) ||
    REVIEW_MODE_FIRM_CODES.includes(SCORM.getFirm()?.toUpperCase()) ||
    Boolean(SCORM.get('clientEditMode'))) &&
  !wordDoc &&
  !audioDoc;

// In authoring context, reflect live toggle from window (if set) without import cycles
try {
  const isAuthor = import.meta.env.MODE?.includes?.('authoring');
  if (isAuthor && typeof window !== 'undefined') {
    // @ts-ignore
    const live = (window as any)?.editModeAvailable as boolean | undefined;
    if (typeof live === 'boolean') {
      isEditModeAvailable = live && !wordDoc && !audioDoc;
    }
  }
} catch {}

export default isEditModeAvailable;
